import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MoveRelatedApiModel, QuizQuestionApiModel } from '@app/api/api-models';
import { CrudService } from '@app/api/api-services/crud.service';
import { HttpClientService } from '@app/api/api-services/http-client.service';
import { sanitizeHtml } from '@shared/utils/editor-utils';

@Injectable()
export class QuizQuestionsService extends CrudService<QuizQuestionApiModel, number> {
  public apiUrl = 'quiz-questions';

  constructor(public http: HttpClientService) {
    super(http);
  }

  public add(model: QuizQuestionApiModel): Observable<QuizQuestionApiModel> {
    model.Text = sanitizeHtml(model.Text);
    return super.add(model);
  }

  public update(model: QuizQuestionApiModel): Observable<QuizQuestionApiModel> {
    model.Text = sanitizeHtml(model.Text);
    return super.update(model);
  }

  public move(model: MoveRelatedApiModel<number, number>): Observable<void> {
    return super.move(model);
  }
}
